"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiResponseError = void 0;
/**
 * Indicates if an API response is unreadable by the client side
 * either because JSON structure is not available or not parsable to EXOResponse
 * @see EXOResponse
 */
class ApiResponseError extends Error {
}
exports.ApiResponseError = ApiResponseError;
//# sourceMappingURL=api-response-error.js.map